import React, { /*useState,*/ useEffect } from 'react';

import {
	simpleGet,
} from '../../Utils';


var req = new XMLHttpRequest();



const Image = ({ linkImage, width, height, fit }) => {

  useEffect(() => {

    simpleGet('http://cdn.assec.app/repo/image.php?img=' + linkImage + '&w=' + width + '&h=' + height + '&fit=' + fit)
      .then(res => { 
  
        console.log('res: ', res)
  
      })
      .catch(e => console.log('Erro:', e))  
  
  }, [])


  //req.open('GET', 'https://temp.assec.pt/repo/image.php?img=' + linkImage + '&w=' + width + '&h=' + height + '&fit=' + fit, false);
  //req.open('GET', 'http://dev4.assec.local/repo/image.php?img=' + linkImage + '&w=' + width + '&h=' + height + '&fit=' + fit, false);
  //req.send(null);
  

  


  return null


  if(req.status === 200) {
     return (
      <img className="img-fluid" src={req.responseText} alt="" />
    );
  }
  else {
    return 'erro';
  }

};

export default Image;
